/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgPersonHeight = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M11 9c.66 0 1.628.19 2.459.788C14.341 10.424 15 11.474 15 13v3h-2v-3c0-.874-.342-1.324-.709-1.589A1.977 1.977 0 0 0 12 11.24V22h-2v-4H8v4H6V11.354a2.65 2.65 0 0 0-.25.177c-.446.357-.75.84-.75 1.469v3H3v-3c0-1.372.696-2.388 1.5-3.031C5.272 9.35 6.237 9 7 9zm-3 7h2v-5H8zm14 6h-7v-2h7zm0-6h-4v-2h4zm0-4h-4v-2h4zM9 2a3 3 0 1 1 0 6 3 3 0 0 1 0-6zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm13 4h-4V6h4zm0-4h-7V2h7z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgPersonHeight as PersonHeight };
